import instance from './axiosInstance';

function exportData(reqBody,
  options = { responseType: 'blob' },
  http = instance) {
  return http.post('/export', reqBody, options);
}

function exportWidgetData(reqBody,
  options = { responseType: 'blob' },
  http = instance) {
  return http.post('/export/widget', reqBody, options);
}

function exportAlertEvents(reqBody,
  options = { responseType: 'blob' },
  http = instance) {
  return http.post('/export/manualAlert/events', reqBody, options);
}

function exportViewerModule(reqBody,
  options = { responseType: 'blob' },
  http = instance) {
  return http.post('/export/sessions', reqBody, { params: { ...reqBody.params } }, options);
}

export {
  exportData, exportWidgetData, exportAlertEvents, exportViewerModule,
};
